<div class="call-us-section">
  <div class="row call-us-row">
    <div class="col-12 custom-col-padding">
      <h2>Prefer to speak to someone?</h2>
    </div>
  </div>
  <div class="row call-us-row">
    <div class="col-12 call-us-col custom-col-padding">
      <common-collapsible-box
        [label]="callUsBox.label"
        [boxId]="callUsBox.id"
        [leftIcon]="callUsBox.leftIcon"
        [rightIcon]="callUsBox.rightIcon"
        [expandedRightIcon]="callUsBox.expandedRightIcon"
        [content]="callUsBox.content"
      >
      </common-collapsible-box>
    </div>
  </div>
</div>
